"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sant-egidio-alla-vibrata": {
    "1bfaeb81": [{
      "hkey": "25eaf7b5",
      "slug": "faraone-nuovo",
      "name": "Faraone Nuovo",
      "primary": true,
      "skipSearch": false
    }],
    "faraone": [{
      "hkey": "25eaf7b5",
      "slug": "faraone-nuovo",
      "name": "Faraone Nuovo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;